import { Translation } from '@ps/web-shared-components';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { qs } from 'url-parse';

import { select } from '@swf/core/store';
import { TabLinkMenu } from '@swf/sports/components';

import type { PromotionTab } from '../IcePromotion/types';

import { TXTCLI_Completed, TXTCLI_Live } from './Tabs.messages.json';

const Tabs: React.FC = () => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const location = useLocation();
  const { tab } = useMemo(() => qs.parse(location.search) as { tab?: PromotionTab }, [location]);

  return (
    <TabLinkMenu>
      <TabLinkMenu.Link isActive={() => tab === undefined} alias="sportsPromotions">
        <Translation {...TXTCLI_Live} />
      </TabLinkMenu.Link>
      {isAuthenticated ? (
        <TabLinkMenu.Link
          alias="sportsPromotions"
          searchParams={new URLSearchParams({ tab: 'COMPLETED' })}
          isActive={() => tab === 'COMPLETED'}
        >
          <Translation {...TXTCLI_Completed} />
        </TabLinkMenu.Link>
      ) : null}
    </TabLinkMenu>
  );
};

export default Tabs;
